var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgReceipt(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.273 1a2.455 2.455 0 0 1 2.45 2.293l.004.162v5.727h2.455c.417 0 .761.312.812.715L19 10v6.545a2.455 2.455 0 0 1-2.293 2.45l-.162.005H3.455a2.455 2.455 0 0 1-2.45-2.293L1 16.545V3.455a2.455 2.455 0 0 1 2.293-2.45L3.455 1h9.818zm0 1.636H3.455a.818.818 0 0 0-.812.716l-.007.103v13.09c0 .418.312.762.716.812l.103.007H14.09V3.454a.818.818 0 0 0-.818-.818zm4.09 8.182h-1.636v6.546h.818a.818.818 0 0 0 .812-.716l.007-.103v-5.727zm-9 1.637a.818.818 0 1 1 0 1.636H5.092a.818.818 0 0 1 0-1.636zm3.273-3.273a.818.818 0 1 1 0 1.636H5.091a.818.818 0 0 1 0-1.636zm0-3.273a.818.818 0 0 1 .103 1.63l-.103.006H5.091a.818.818 0 0 1-.103-1.63l.103-.006h6.545z",
    fill: "#FFF",
    fillRule: "nonzero"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReceipt);
export default __webpack_public_path__ + "static/media/receipt.b5e2c1cd57bad1bad9ae5abe8eff9789.svg";
export { ForwardRef as ReactComponent };